module.exports = __webpack_public_path__ + "img/logo.4d6937f2.png";